import {
  typeChildWedding,
  typeForGet,
  typeFuneral,
  typeInsurance,
  typeMaternity,
  typeMyWedding,
  typeOT,
  typeOTHoliday,
  typeOTWeekend,
  typeOffPay,
  typeOffUnPay,
  typeOut,
  typeSummer,
  typeWFH,
  typeWomen
} from '../constants/submitType'
const submitTypeConstant = [
  typeForGet,
  typeFuneral,
  typeInsurance,
  typeMaternity,
  typeMyWedding,
  typeOT,
  typeOTHoliday,
  typeOTWeekend,
  typeOffPay,
  typeOffUnPay,
  typeOut,
  typeSummer,
  typeWFH,
  typeWomen,
  typeChildWedding
]

export function getDataSubmitToGoogleForm(email: string, data: any) {
  const formData = []
  switch (data.typeSubmit) {
    case typeOT.value:
    case typeForGet.value:
    case typeWFH.value:
    case typeOTHoliday.value:
    case typeOTWeekend.value:
    case typeOut.value: {
      formData.push(email)
      formData.push('Form chấm công (TimeSheet)')
      const itemSubmitType = submitTypeConstant.filter((item) => {
        return item.value === data.typeSubmit
      })
      formData.push(itemSubmitType[0].label)
      formData.push(formatDate(data.dateSubmit))
      if (data.timeStart) formData.push(formatTime(data.timeStart))
      else formData.push('')
      if (data.timeEnd) formData.push(formatTime(data.timeEnd))
      else formData.push('')
      if (data.reason) formData.push(data.reason)
      else formData.push('')
      break
    }
    case typeOffPay.value:
    case typeOffUnPay.value:
    case typeInsurance.value: {
      formData.push(email)
      formData.push('Form nghỉ phép')
      const itemSubmitType2 = submitTypeConstant.filter((item) => {
        return item.value === data.typeSubmit
      })
      formData.push(itemSubmitType2[0].label)
      if (data.typeDate == 'all_day') {
        formData.push('Cả ngày')
      } else {
        formData.push('Nửa ngày (0.5)')
      }
      formData.push(formatDate(data.startDate))
      if (data.typeDate == 'all_day') {
        if (data.endDate) formData.push(formatDate(data.endDate))
      } else {
        formData.push(formatDate(data.startDate))
      }
      if (data.reason) formData.push(data.reason)
      else formData.push('')
      break
    }
    case typeWomen.value:
    case typeSummer.value:
    case typeMyWedding.value:
    case typeChildWedding.value:
    case typeFuneral.value: {
      formData.push(email)
      formData.push('Form nghỉ phép')
      const itemSubmitType3 = submitTypeConstant.filter((item) => {
        return item.value === data.typeSubmit
      })
      formData.push(itemSubmitType3[0].label)
      formData.push(formatDate(data.startDate))
      if (data.reason) formData.push(data.reason)
      else formData.push('')
      break
    }
    case typeMaternity.value: {
      formData.push(email)
      formData.push('Form nghỉ phép')
      const itemSubmitType4 = submitTypeConstant.filter((item) => {
        return item.value === data.typeSubmit
      })
      formData.push(itemSubmitType4[0].label)
      formData.push('Cả ngày')
      formData.push(formatDate(data.startDate))
      formData.push(formatDate(data.endDate))
      formData.push('')
      break
    }
  }
  return formData
}

function formatDate(data: string) {
  const date = new Date(Date.parse(data)) // Convert the date to a Date object
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return [year, month, day].join('-')
}

function formatTime(data: string) {
  const date = new Date(Date.parse(data)) // Convert the date to a Date object
  const h = date.getHours()
  let hours = ''
  let minutes = ''
  if (h < 10) {
    hours = '0' + h
  } else {
    hours = String(h)
  }
  const m = date.getMinutes()
  if (m < 10) {
    minutes = '0' + m
  } else {
    minutes = String(m)
  }
  return [hours, minutes].join(':')
}
